import React, { Component } from "react";

/**
 * Dual media surface — HTMLVideoElement for HLS/MP4 + embed mount for
 * YouTube/Vimeo providers. Engine chooses which surface is active.
 */
class MediaSurface extends Component {
  constructor(props) {
    super(props);
    this.videoEl = null;
    this.embedEl = null;
    this.setVideoRef = this.setVideoRef.bind(this);
    this.setEmbedRef = this.setEmbedRef.bind(this);
    this._notify = this._notify.bind(this);
  }

  _notify() {
    if (this.props.onAttach && this.videoEl && this.embedEl) {
      this.props.onAttach({
        video: this.videoEl,
        embed: this.embedEl,
      });
    }
  }

  setVideoRef(el) {
    this.videoEl = el;
    this._notify();
  }

  setEmbedRef(el) {
    this.embedEl = el;
    this._notify();
  }

  componentWillUnmount() {
    if (this.props.onDetach) {
      this.props.onDetach();
    }
  }

  render() {
    var poster = this.props.poster || undefined;
    return (
      <div className="ngp-media-surface">
        <video
          ref={this.setVideoRef}
          className="ngp-video"
          poster={poster}
          playsInline
          preload="metadata"
          controls={false}
        />
        <div
          ref={this.setEmbedRef}
          className="ngp-embed-root"
          aria-hidden="true"
        />
      </div>
    );
  }
}

export default MediaSurface;
